module.exports = __webpack_public_path__ + "img/guaranteed_irish.4135112.svg";